import { render, staticRenderFns } from "./ForfaitResetWarning.vue?vue&type=template&id=ab3e5dc4&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ForfaitResetWarning.vue"
export default component.exports